module.exports = __webpack_public_path__ + "4146894d337dd502f99c6687bb26bd74.svg";